<template>
  <div id="investor">
    <NavigationBar />
    <HeroSectionInvestor />
    <TrustSection />
    <BusinessModel />
    <CompetitiveMoat />
    <MarketSize />
    <DevelopmentRoadmap />
    <WhitepaperDownload />
    <InvestorContent />
    <FooterSection />
  </div>
</template>

<script>
import NavigationBar from '@/components/Navigation.vue'
import HeroSectionInvestor from '@/components/HeroSectionInvestor.vue'
import TrustSection from '@/components/TrustSection.vue'
import BusinessModel from '@/components/BusinessModel.vue'
import CompetitiveMoat from '@/components/CompetitiveMoat.vue'
import MarketSize from '@/components/MarketSize.vue'
import DevelopmentRoadmap from '@/components/DevelopmentRoadmap.vue'
import WhitepaperDownload from '@/components/WhitepaperDownload.vue'
import InvestorContent from '@/components/InvestorContent.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'InvestorPage',
  components: {
    NavigationBar,
    HeroSectionInvestor,
    TrustSection,
    BusinessModel,
    CompetitiveMoat,
    MarketSize,
    DevelopmentRoadmap,
    WhitepaperDownload,
    InvestorContent,
    FooterSection
  }
}
</script>

<style scoped>
#investor {
  width: 100%;
}
</style>
